import RouteGoverness from './routeGoverness';
import { ROUTES } from '../../plugins/types';
export default class AuthenticatedRouteGoverness extends RouteGoverness {
    constructor ({from, to, next}) {
        super({from, to, next});
    }

    guard (action) {
        if (super.isNotAllowed(action)) {
            return this.redirectTo(ROUTES.LOGIN);
        }

        return this.next();
    }
}
